import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { subscriptionService, type CreateSubscriptionResponse } from '@/services/subscription/subscription.service';
import { useTranslation } from 'react-i18next';

export const useTopUpSubscription = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<CreateSubscriptionResponse, Error, void>({
    mutationFn: async () => {
      const response = await subscriptionService.topUpSubscription() as CreateSubscriptionResponse | { data: CreateSubscriptionResponse };
      return 'data' in response ? response.data : response;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
      queryClient.invalidateQueries({ queryKey: ['payments'] });
      
      const payment = data.payment || (data as { payment?: unknown }).payment;
      if (payment?.paymentLinkUrl) {
        try {
          window.open(payment.paymentLinkUrl, '_blank', 'noopener,noreferrer');
          toast.success(t('billing.toasts.topUpPaymentWindowOpened') || 'Payment window opened');
        } catch (error) {
          console.error('Failed to open payment window:', error);
          toast.error(t('billing.toasts.failedToOpenPaymentWindow') || 'Failed to open payment window');
        }
      } else {
        toast.warning(t('billing.toasts.paymentUrlMissing') || 'Payment URL not available');
      }
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || error?.message || t('billing.toasts.topUpFailed') || 'Failed to top up subscription';
      toast.error(errorMessage);
    },
  });
};

